RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const OTHER_BUCKET_COLOR = '#777777';

    function mapCountryCodesToCountries(demographics) {
        return _.mapKeys(demographics, function (value, countryCode) {
            return RivalIQ.utils.countryCodes.codes[countryCode] || countryCode;
        });
    }

    const Demographics = RivalIQ.views.LayoutView.mixin({
        regions: {
            chart: '.chart-region'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        ui: {
            noDataMsg: '.x-no-data-msg',
            demographics: 'ul',
            popovers: '[data-toggle="popover"]',
            hideOnNoData: '.hide-no-data'
        },

        events: {
            'click .pointer': 'showModal'
        },

        dashboardModelEvents: {
            'change:timePeriod': 'reload'
        },

        className: function () {
            const me = this;
            const className = me.dashboardModel.distributionClassName || '';
            return `${className} chart widget-insights-demographics`;
        },

        template: '#widgetInsightsDemographicsTemplate',

        loadData: function () {
            const me = this;

            return App.utils.constructInsightsCompanyDataFetch(me.getProps()).then(function (cd) {
                me.companyData = cd;

                const trendKey = RivalIQ.enums.sourceDetails[me.getProp('source')].trendKey;
                me.dataWarning = _.get(cd, [
                    'compareData',
                    'companies',
                    0,
                    'periodSummary',
                    trendKey,
                    0,
                    'dataWarning'
                ]);
            });
        },

        serializeData: function () {
            const me = this;

            const timePeriod = me.getProp('timePeriod');

            const notEnoughDataDescription = App.utils.getNotEnoughDataDescription(me.dashboardModel, me.dataWarning, timePeriod);

            return {
                metricLabel: me.dashboardModel.getMetricLabel(),
                exportHeightClass: me.dashboardModel.isExportingPPT() ? 'no-data-msg-container-export' : '',
                notEnoughDataDescription: notEnoughDataDescription
            };
        },

        onAttachLoaded: function () {
            const me = this;

            const demographicsResult = me.getDemographics();

            if (!demographicsResult || _.isEmpty(demographicsResult)) {
                me.ui.noDataMsg.removeClass('hide');
                me.ui.hideOnNoData.addClass('hide');
            } else {
                me.ui.noDataMsg.addClass('hide');
                me.ui.hideOnNoData.removeClass('hide');

                // NOTE we have to render the chart first so that we can use it to
                // accurately provide colors in the countries
                me.showChart();
                me.showDemographics();
            }

            me.ui.popovers.popover({
                html: true
            });
        },

        getHeight: function () {
            const me = this;

            if (me.dashboardModel.isExportingPPT()) {
                return 380;
            }

            // this is to grab the height for specifically the FB Insight Reach by Gender donut
            // that is the only donut that is in a widget by itself
            if (me.getProp('height')) {
                return me.getProp('height');
            }

            return 200;
        },

        getWidth: function () {
            const me = this;

            if (me.dashboardModel.isExportingPPT()) {
                return 400;
            }
        },

        showChart: function () {

            const me = this;
            const demographics = _.toPairs(me.getDemographics());
            const demographicType = me.getProp('demographicType');

            // NOTE if 'other' exists, it is forced to the end of the array
            const data = demographics.sort(function (a, b) {
                if (b[0] === 'other') {
                    return -1;
                }
                return b[1] - a[1];
            });

            const view = me.pieChart = new RivalIQ.graph.Donut({
                margin: {
                    top: 0,
                    bottom: 0
                },
                rotation: 0,
                height: me.getHeight(),
                width: me.getWidth(),
                limit: me.getProp('limit'),
                dataProperty: 'data',
                shouldAddRemainder: true,
                graphOptions: {
                    showLabelsInside: false,
                    onSliceClick: _.bind(me.showModal, me)
                },
                data: data
            });

            if (demographicType === 'gender_age' || demographicType === 'reach-by-age-gender' || demographicType === 'fans-by-age-gender') {
                me.pieChart.options.colorFun = me.getColors();
            } else {
                const donutColorFcn = me.pieChart.color();
                me.pieChart.options.colorFun = function (d, i) {
                    if (d.isOther || _.head(d) === 'Others') {
                        return OTHER_BUCKET_COLOR;
                    }
                    return donutColorFcn(d, i);
                };
            }

            me.chart.show(view);
        },

        getColors: function () {
            return function (d) {
                // d.country & d.demographic so we catch the legend colors in the widget & in the breakdown modal
                if ((d[0] || d.country || d.demographic) === 'Women') {
                    return RivalIQ.enums.colors.female;
                } else if ((d[0] || d.country || d.demographic) === 'Men') {
                    return RivalIQ.enums.colors.male;
                } else {
                    return RivalIQ.enums.colors.unspecified;
                }
            };
        },

        showDemographics: function () {

            const me = this;
            const demographics = me.getDemographics();
            const limit = parseInt(me.getProp('limit'));

            const data = _.map(demographics, function (value, country) {

                return {
                    country: country,
                    value: value
                };
            });

            // NOTE if 'other' exists, it is forced to the end of the array
            data.sort(function (a, b) {
                if (b.country === 'other') {
                    return -1;
                }
                return b.value - a.value;
            });

            if (_.isFinite(limit) && data.length > limit) {

                const total = _.reduce(data.slice(limit), function (sum, datum) {

                    return sum + datum.value;
                }, 0);

                data.splice(limit, data.length - limit, {
                    country: 'Other',
                    isOther: true,
                    value: total
                });
            }

            const html = _.map(data, function (datum, index) {

                const color = me.pieChart.options.colorFun(datum, index);

                return $.tagHtml('li', {
                    html: [
                        $.tagHtml('i', {
                            style: `color: ${color};`,
                            class: ['fa', 'fa-fw', 'fa-square']
                        }),
                        $.tagHtml('span', {
                            text: `${datum.country}:`
                        }),
                        $.tagHtml('strong', {
                            text: RivalIQ.formatter.formats.abbreviated(datum.value)
                        })
                    ].join('')
                });
            }).join('');

            me.ui.demographics.html(html);
        },

        getDemographics: function () {
            const me = this;
            const companyId = me.getProp('companyId');
            const company = me.companyData.get(companyId).toJSON();

            const source = me.getProp('source');
            const locationType = me.getProp('locationType') || 'country';
            const demographicType = me.getProp('demographicType') || 'country';
            if (source === RivalIQ.enums.sources.FACEBOOK_INSIGHTS) {
                let demographics = RivalIQ.utils.companyDisplay.getFacebookDemographics(company, locationType, demographicType);

                if (_.includes(['fans-by-country', 'reach-by-country'], demographicType)) {
                    demographics = mapCountryCodesToCountries(demographics);
                }

                return demographics;
            } else if (source === RivalIQ.enums.sources.LINKEDIN) {
                return RivalIQ.utils.companyDisplay.getLinkedInDemographics(company, demographicType);
            } else if (source === RivalIQ.enums.sources.INSTAGRAM_INSIGHTS) {
                let instaDemographics = RivalIQ.utils.companyDisplay.getInstaDemographics(company, demographicType);

                if (demographicType === 'country') {
                    instaDemographics = mapCountryCodesToCountries(instaDemographics);
                }

                return instaDemographics;
            } else {
                return [];
            }
        },

        showModal: function () {

            const me = this;

            const view = new RivalIQ.apps.CompanyProfile.views.DemographicsBreakdown({
                title: me.dashboardModel.getMetricLabel(),
                companyId: me.getProp('companyId'),
                locationType: me.getProp('locationType'),
                demographicType: me.getProp('demographicType'),
                companyData: me.companyData,
                source: me.getProp('source'),
                colorFun: me.pieChart.options.colorFun
            });

            RivalIQ.execute('show:modal', view);
        }
    });

    const DemographicsWidget = RivalIQ.apps.Dashboard.models.Widget.extend({

        viewMore: false,
        scheduledExportAdvancedSettingsEnabled: false,

        processProps: function (props) {
            _.defaults(props, {
                limit: 4
            });

            return props;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSIGHTS_DEMOGRAPHICS, DemographicsWidget.extend({
        view: Demographics,

        getMetricLabel: function () {
            const me = this;
            let metricLabel;

            if (me.getProp('source') === RivalIQ.enums.sources.LINKEDIN) {
                switch (me.getProp('demographicType')) {
                    case 'city':
                        metricLabel = RivalIQ.strings.linked_in_insights_demographics_followers_by_city;
                        break;
                    case 'country':
                        metricLabel = RivalIQ.strings.linked_in_insights_demographics_followers_by_country;
                        break;
                    case 'industry':
                        metricLabel = RivalIQ.strings.linked_in_insights_demographics_followers_by_industry;
                        break;
                    case 'job-function':
                        metricLabel = RivalIQ.strings.linked_in_insights_demographics_followers_by_job_function;
                        break;
                    default:
                        metricLabel = RivalIQ.strings.linked_in_insights_demographics_followers_by_country;
                        break;
                }
            } else if (me.getProp('source') === RivalIQ.enums.sources.FACEBOOK_INSIGHTS) {
                // remove if (me.getProp('locationType')) after private v2
                if (me.getProp('locationType')) {
                    switch (me.getProp('locationType')) {
                        case 'city':
                            metricLabel = RivalIQ.strings.facebook_insights_demographics_fans_by_city;
                            break;
                        case 'country':
                            metricLabel = RivalIQ.strings.facebook_insights_demographics_fans_by_country;
                            break;
                        case 'impressions-by-city':
                            metricLabel = RivalIQ.strings.facebook_insights_demographics_reach_by_city;
                            break;
                        case 'impressions-by-country':
                            metricLabel = RivalIQ.strings.facebook_insights_demographics_reach_by_country;
                            break;
                        default:
                            throw new Error(`unknown location type ${me.getProp('locationType')}`);
                    }
                } else {
                    // only keep this switch statement after private v2
                    switch (me.getProp('demographicType')) {
                        case 'fans-by-city':
                            metricLabel = RivalIQ.strings.facebook_insights_demographics_fans_by_city_label;
                            break;
                        case 'fans-by-country':
                            metricLabel = RivalIQ.strings.facebook_insights_demographics_fans_by_country_label;
                            break;
                        case 'reach-by-city':
                            metricLabel = RivalIQ.strings.facebook_insights_demographics_reach_by_city_label;
                            break;
                        case 'reach-by-country':
                            metricLabel = RivalIQ.strings.facebook_insights_demographics_reach_by_country_label;
                            break;
                        case 'reach-by-age-gender':
                            metricLabel = RivalIQ.strings.facebook_insights_demographics_reach_by_age_gender;
                            break;
                        default:
                            metricLabel = 'Demographics';
                            break;
                    }
                }


            } else { // source is INSTAGRAM_INSIGHTS
                switch (me.getProp('demographicType')) {
                    case 'city':
                        metricLabel = RivalIQ.strings.instagram_insights_demographics_city_metric_label;
                        break;
                    case 'country':
                        metricLabel = RivalIQ.strings.instagram_insights_demographics_country_metric_label;
                        break;
                    case 'gender_age':
                        metricLabel = RivalIQ.strings.instagram_insights_demographics_age_gender_metric_label;
                        break;
                    default:
                        throw new Error(`unknown demographic type ${me.getProp('demographicType')}`);
                }
            }

            return metricLabel;
        }
    }));
});
